import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import Helper from 'utils/helpers';
import { LANGUAGE_DISPLAY } from 'utils/config';
import * as locales from './resources';

i18n
  // pass the i18n instance to react-i18next.
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: Helper.getLang() || LANGUAGE_DISPLAY,
    fallbackLng: Helper.getLang() || LANGUAGE_DISPLAY,
    resources: {
      ...Object.entries(locales).reduce(
        (acc, [key, value]) => ({
          ...acc,
          [key]: value,
        }),
        {},
      ),
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
